(function() {
'use strict';


angular
    .module('ekh')
    .service('cmsPageMapping', cmsPageMapping);

function cmsPageMapping(destinationService) {
    function filterPages(filterType) {
        return destinationService.getTiles({ ControlId: 222 })
            .then(tiles => _.filter(tiles[0], tile => {
                if (tile.pagetype === filterType) {
                    return {
                        Name: tile.name,
                        ControlId: tile.controlid,
                        LinkUrl: tile.linkurl
                    };
                }
            }));
    }

    return {
        getDestinations: () => filterPages('destination'),
        getHomePage: () => filterPages('homepage'),
        getOfferTypes: () => filterPages('offer'),
        getSingleOffers: () => filterPages('singleoffer')
    };
}
})();
